import { gql } from '@apollo/client'
import { pick } from 'ramda'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import React from 'react'

import { analyticsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import { useWidgetState } from '../../../WidgetWrapper'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useGroupedEventsByReasonState = () => React.useContext(Context)
export const useGroupedEventsByReason = () => useGroupedEventsByReasonState()?.groupedEventsByReason

const QUERY = gql`
  query GroupedEventsByReason($filter: GroupedEventsByReasonFilter) {
    groupedEventsByReason(filter: $filter) {
      id
      name
      count
    }
  }
`

const GroupedEventsByReasonLoader = ({ children }) => {
  const filter = useCleanFilterForRequest() || {}
  const { value } = useWidgetState()

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: {
        statusIds: value?.status?.id || 10,
        ...pick(['placeIds', 'placeLevelIds', 'userIds', 'checklistIds', 'date'], filter)
      }
    },
    client: analyticsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default GroupedEventsByReasonLoader
